import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'app/services/api.service';

@Component({
  selector: 'app-service-edit-view-available-propers',
  templateUrl: './service-edit-view-available-propers.component.html',
  styleUrls: ['./service-edit-view-available-propers.component.css']
})
export class ServiceEditViewAvailablePropersComponent implements OnInit {
 
public isLoading: Boolean;
public entities: any[];

@Input() serviceId: string;  
@Input() properId: string;  
 

constructor(public apiSvc: ApiService) { }

ngOnInit() {
 
  this.loadMappings();
}
 
public loadMappings() {
  console.log("Load Mappings");

  var payload = {
    ServiceId: this.serviceId,
    ProperId: this.properId
  }

  this.isLoading = true;
  this.apiSvc.post("api/ServiceProperHtmlOptions/GetPropersOptions", payload, null).subscribe(
    (data: any) => {
      this.entities = data;
      console.log(data); 
      this.isLoading = false;
    },
    (err) => { 
      alert("Could not get the HTML options for this service");
      console.log(err);
      this.isLoading = false;
    }
  );
}

public getHtmlUrl(entity: any) { 

  console.log("getHtmlUrl", entity);
  var url = "../assets/proper-preview.html"; 

  //Resetting the value in local storage in case it was removed. Looking to avoid the user from logging back in and/or reloading the app
  this.apiSvc.assignBaseUrlToLocalStorage();

  var options = {
    Method: "ServiceView",
    ServiceId: this.serviceId,  
    ProperId: this.properId,
    LiturgyType: entity.LiturgyType,
    LectionaryYear: entity.LectionaryYear
  };

  let params = new URLSearchParams();
  for(let key in options){
      params.set(key, options[key]) 
  }

  var url = url + "?" + params.toString();
  console.log(url);

  return url;
}

}
 

export class MappingFilterModel {
public Year: string;
public Date: Date;
}